import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BookingComponent } from '../BookingComponent';
import * as _ from 'lodash'
import * as moment from 'moment'

import { DiscoundConfig, Payment } from '../../../models';
// Services
import { BookingHolidayService } from '../../../services';
import { EmailService } from '../../../services';
import { SessionStorageService, FileService, CatalogService, LocalStorageService } from '../../../../common/modules/core/services';

@Component({
    selector: 'complete',
    template: require('./PaymentComponent.html'),
    styles: [ require('./PaymentComponent.sass') ]
})

export class PaymentComponent extends BookingComponent implements OnInit {
    private booking: any;
    private filteredExcursions: string = '';
    private singleBusPrice: number = 750000;
    private btBusCost: number = 0;
    // private othersBusCost: number = 1950000;
    private busCost: number = 0;
    private startDate: string;
    private endDate: string;
    private duration: string;
    private loadingSubmit: boolean;
    // private isAisParent: string = '';
    currentSemester: any = {
        name: ''
    }
    // Lunch
    private singleLunchPrice: number = 186000;
    private lunchPrice: number = 0;
    private checkLunch: any = '';
    private checkBus: any = '';
    private payment: Payment;
    private isDisableBusCheck: boolean = false;
    private paymentType: string;
    private surveySelect: string = '';
    private showSurveyMessage: boolean = false;
    private totalAmount: any[];

    private isLearnFullWeek: boolean;
    private totalAmountCourse: number;
    private totalCost: number;
    private earlyBirdConfig: DiscoundConfig;

    constructor(
        protected fileService: FileService,
        protected router: Router,
        protected emailService: EmailService,
        protected sessionStorageService: SessionStorageService,
        protected local: LocalStorageService,
        protected services: BookingHolidayService,
        protected catalogService?: CatalogService
    ) {
        super(router, services, sessionStorageService, catalogService);
        this.totalAmount = [];
    }

    ngOnInit() {
        this.getSemester();
        // this.isAisParent = this.sessionStorageService.getData("isAisParent").toString();
        this.payment = new Payment; 
        this.loadingSubmit = false;
        // Get booking info
        this.booking = this.getBooking();
        // If bus is registered
        this.checkBus = !_.isEmpty(this.booking.bus) ? true : false;
        this.isDisableBusCheck = !_.isEmpty(this.booking.bus) ? true : false;
        // Check lunch on editing
        if(this.booking.lunch){
            this.checkLunch = true;
        }
        // Check survey on editing
        if(this.booking.survey){
            this.surveySelect = this.booking.survey;
        }
        // Sum lunch price
        // this.countLunchPrice();
        // Filter excursion
        this.filterExcursion();
        // Get start/end date of class
        this.getStartEndDate();
        this.getEarlyBirdConfiguration();
        this.earlyBirdDiscount();
        this.paymentType = "";

        this.isLearnFullWeek = false;
        if(this.booking.allWeek.length == this.booking.periodWeeks.length)
            this.isLearnFullWeek = true;

        this.calculatorTotalAmount();
        this.calculatorBusCost();
        this.calculatorLunchCost();     
        
        this.checkLunch = true;
    }

    getEarlyBirdConfiguration() {
        this.services.getDiscountConfig('early-bird')
        .subscribe(
            config => {
                this.earlyBirdConfig = config;
            }
        )
    }

    // Retrieve start/end date base on week
    getStartEndDate(){
        let start: string;
        let end: string;

        // Init start/end date
        // if(this.booking.allWeek){
        //     start = this.booking.allWeek[0].start_date;
        //     end = this.booking.allWeek[0].end_date;
        //     this.duration = this.booking.allWeek[0].name + ', ';
        // }

        // _.forEach(this.booking.periodWeeks, (pVal, pKey) => {
        //     if(pKey){
        //         let week : any = _.find(this.booking.allWeek, {'id': pVal});
        //         this.duration = this.duration + week.name + ', ';
        //         if(week){
        //             // Compare start date
        //             if(moment(week.start_date).isBefore(start)){
        //                 start = week.start_date;
        //             }
        //             // Compare end date
        //             if(moment(week.end_date).isAfter(end)){
        //                 end = week.end_date;
        //             }
        //         }
        //     }
        // })

        //this.duration = this.duration.slice(0, -2);
        
        const weekSelected: any = this.booking.allWeek.filter((item: any) => {
            if(this.booking.periodWeeks.filter((week: any) => week == item.id).length > 0)
                return true;
            else
                return false;
        });

        this.duration = weekSelected.map((item: any) => item.name).join(',');
        
        start = weekSelected.map((item: any) => item.start_date).reduce((a: any, b: any) => moment(a).isBefore(b) ? a : b);
        end = weekSelected.map((item: any) => item.end_date).reduce((a: any, b: any) => moment(a).isAfter(b) ? a : b);
        
        this.startDate = start;
        this.endDate = end;
    }
    disabledSumit() {
        if(this.paymentType === undefined || this.surveySelect === '') {
            return true
        }
        else {
            return false
        }
    }
    // Filter to get excursion weeks
    filterExcursion() {
        if(!_.isEmpty(this.booking.selectedExcursion)){
            _.forEach(this.booking.weeks, (val, key) => {
                if(val.excursions.length){
                    let week:any = _.find(this.booking.allWeek, {'id': val.hol_week_id});
                    this.filteredExcursions = this.filteredExcursions + week.name + ', ';
                }
            })
        }

        return this.filteredExcursions = _.trimEnd(this.filteredExcursions, ', ');
    }

    // Calculate lunch price based on selected week
    countLunchPrice() {
        return this.lunchPrice = this.booking.weeks.length * this.singleLunchPrice;
    }

    // Calculate total cost
    countTotalCost() {

        // Class cost by weeks
        let classCost = this.totalAmountCourse;
        
        if(this.booking.busType == 'paid'){
            if (this.booking.bus.district === 'Binh Thanh') {
                 this.btBusCost = 1500000
            }
            if(this.booking.bus.district === 'Others'){
                this.calculatorBusCost()
            }
        }
        else {
            this.btBusCost = 0;
        }

        if(this.btBusCost > 0) {
            this.booking.bus.price = this.btBusCost;
        }
        
        // basically total will be equal to class cost if no option was selected
        this.totalCost = classCost;

        // If have Bus fee
        if(this.checkBus && this.booking.busType == 'paid'){
            this.totalCost = this.totalCost + this.btBusCost;
        }

        // If have Lunch fee
        if(this.checkLunch){
            this.totalCost = this.totalCost + this.lunchPrice;
        }

        return this.totalCost;
    }

    // // Download Lunch menu
    // downloadLunchMenu(){
    //     const link = window.document.createElement('a');
    //     link.href = '/assets/AIS Summer Menu - 2017-18.xlsx';
    //     link['download'] = "AIS Summer Menu - 2017-18.xlsx";
        
    //     document.body.appendChild(link);
    //     link.click();

    //     setTimeout(function(){
    //         document.body.removeChild(link);
    //     }, 100);
    // }

    earlyBirdDiscount() {
        let getCurrentDay = moment(new Date()).format('YYYY-MM-DD');
        if (this.earlyBirdConfig) {
            const deadline = this.earlyBirdConfig.condition;
            if (new Date(getCurrentDay).getTime() <= new Date(deadline).getTime() && this.paymentType != ""){
                return true
            }
        }
        return false
    }


    protected getSemester() { 
        this.catalogService.getSemesters()
            .subscribe(
                semesterList => {
                    this.currentSemester = _.find(semesterList, 'is_current');
                    //count total cost
                    this.countTotalCost();
                },
                error => {
                    console.log("Cannot get semester list from API.");
            }
        )
    }

    // Submit payment
    submitPayment() {
        // Notice when not select survey
        if(!this.surveySelect){
            return this.showSurveyMessage = true;
        }

        // Active loading payment
        this.loadingSubmit = true;
        
        if(this.checkBus && this.booking.busType == 'paid'){
            this.booking.bus.price = this.btBusCost;
        }

        // Collect query data
        let query = {
            id: this.booking.id,
            name: this.booking.name,
            payment_method: this.booking.payment_method,
            weeks: this.booking.weeks,
            survey: this.surveySelect,
            lunch: this.checkLunch ? true : false,
            hol_class_id: this.booking.hol_class_id,
            hol_student_id: this.booking.hol_student_id,
            send_email: 1,
            question_answer: this.booking.question_answer
        }

        if(!_.isEmpty(this.booking.bus)){
            query['bus'] = this.booking.bus;
        }
        
        // Update booking to new real one
        this.services.updateBooking(query).subscribe(
            result => {
                this.loadingSubmit = false;
                if(result.data) {
                    this.booking.code = this.booking.id;
                    this.payment.booking_id = this.booking.code;
                    this.payment.currency = 'VND';
                    this.payment.zone = this.paymentType;
                    this.payment.amount = this.countTotalCost();
                    // Payment information
                    if(this.payment.zone === 'domestic' || this.payment.zone === 'international'){
                        this.services.payment(this.payment)
                            .subscribe(
                                (result: any) => {                                    
                                    this.local.setData('updateBookingDetail', result);
                                    this.services.getChildren().subscribe(
                                        result => {
                                            this.setHolidayChildren(result);
                                        },
                                        error => {
                                    
                                        }
                                    )
                                    window.location.href = result.url
                                },
                                (error: any) => {

                                }
                            )
                    }
                    else if(this.payment.zone === '') {
                        this.setBooking(this.booking);
                        this.router.navigate(['booking/finish']);
                    }
                }
            },
            error => {
                this.loadingSubmit = false;
            }
        )
    }

    private calculatorTotalAmount() {
        const isEarlyBirdDiscount: boolean = this.earlyBirdDiscount();
        // if(this.isAisParent === 'true')
        //     this.totalAmountCourse = this.getTotalForAIS();
        // else 
        if (this.isLearnFullWeek)
            this.totalAmountCourse = this.booking.class.total_cost;
        else
            this.totalAmountCourse = this.booking.class.prices.map((item: any) => {
                if (this.booking.periodWeeks.filter((week: any) => week == item.hol_week_id).length > 0) {
                    return item.price;
                }
                else
                    return 0;
            }).reduce((current: any, next: any) => current + next, 0);

        if (this.booking.discount.discount || (isEarlyBirdDiscount && this.checkFullWeek())){
            const discountPercent = this.earlyBirdConfig ? Number(this.earlyBirdConfig.value)/100 : 0.1;
            this.totalAmountCourse = this.totalAmountCourse - (this.totalAmountCourse * discountPercent);
        }
        return this.totalAmountCourse;
    }


    // private getTotalForAIS () {
    //     return this.booking.class.prices.map((item: any) => {
    //         if (this.booking.periodWeeks.filter((week: any) => week == item.hol_week_id).length > 0) {
    //             if([1,2].indexOf(item.hol_week_id) > -1){
    //                 return 0; 
    //             }
    //             else
    //                 return item.price;
    //         }
    //         else
    //             return 0;
    //     }).reduce((current: any, next: any) => current + next, 0);
    // }

    private calculatorLunchCost(){
        this.lunchPrice = this.booking.allWeek.map((item: any) => {
            if(this.booking.periodWeeks.filter((week: any) => week == item.id).length > 0)
                return item.lunch_cost;
            else
                return 0;
        }).reduce((current: any, next: any) => current + next, 0);
    }
    
    private calculatorBusCost(){
        this.btBusCost = this.booking.allWeek.map((item: any) => {
            if(this.booking.periodWeeks.filter((week: any) => week == item.id).length > 0)
                return item.bus_cost;
            else
                return 0;
        }).reduce((current: any, next: any) => current + next, 0);
    }

    private checkFullWeek(){
        if(this.booking.periodWeeks.length == this.booking.allWeek.length){
            return true;
        }
        return false;
    }

}



// WEBPACK FOOTER //
// ./src/holiday/parent/booking/6-payment/PaymentComponent.ts